(function($) {
  function getProduct() {
    return $.getJSON('');
  }

  function initProductImagesPhotoswipe() {
    var pswpElement = document.querySelectorAll('.pswp')[0];

    var initialIndex = parseInt($('.photoswipe-trigger a').attr('data-index')) - 1;
    initialIndex = Flickity.data('.product_gallery').selectedIndex;

    var pswp_options = {
      index: initialIndex
    };

    var images = [];
    $.each(_product.images, function(index, image) {
      images.push({
        src: image.src,
        w: image.width,
        h: image.height
      });
    });
    //console.log({images});

    // Initializes and opens PhotoSwipe
    var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, images, pswp_options);

    // events
    gallery.listen('destroy', function() {});

    gallery.init();

    return gallery;
  }
  
  function mobileImagesZoom() {
    var isProductPage = window.location.pathname.indexOf('/products') !== -1;
    if (isProductPage) {
      function setPhotoswipeTrigger() {
        $('.photoswipe-trigger').css({
          top: $('.product_gallery').height() + 5
        });

        $('.photoswipe-trigger').addClass('visible');      
      }
      setTimeout(setPhotoswipeTrigger, 1000);
      setTimeout(setPhotoswipeTrigger, 2000);

      $('.photoswipe-trigger a').on('click', function(e) {
        //console.log(e);
        e.preventDefault();
        e.stopPropagation();
        initProductImagesPhotoswipe();
      });
    }    
  }
  
  function giftCart() {
    $(document).on('change', '[name="attributes\[gift-bag\]"]', function() {
      if ($(this).is(':checked')) {
        Shopify.Cart.GiftBag.set();    
      }
      else {
        Shopify.Cart.GiftBag.remove();
      }
    });    
  }
  
  function klaviyoFix() {
    function updateButtons(variant) {
      if (variant.available) {
        $('.product .shopify-product-form button.add_to_cart').removeClass('disabled').prop('disabled', false);
        $('.klaviyo-bis-trigger').hide();
      }
      else {
        $('.product .shopify-product-form button.add_to_cart').addClass('disabled').prop('disabled', true);
        $('.klaviyo-bis-trigger').show();
      }
    }
    
    $(document).on('variant-change', function(e) {
      //console.log(e);
      setTimeout(function() {
        updateButtons(e.variant);
      }, 100);
    });
  }

  function PDP_openDescription() {
    var all_initial_open = document.querySelectorAll('.accordion [data-initial="true"]')

    Array.from(all_initial_open).forEach(item => {
      $(item).click()
    })


  }
  
  $(document).ready(function() {
    console.log('READY');
    mobileImagesZoom();
    giftCart();
    klaviyoFix();
    PDP_openDescription();
  });
})(jQuery);